var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        attrs: { method: "POST", action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.WishListAction()
          },
        },
      },
      [
        _c("div", { staticClass: "header" }, [
          _c("span", { staticClass: "title" }, [
            _vm.modalTitle
              ? _c("span", [_vm._v(_vm._s(_vm.modalTitle))])
              : _c("span", [_vm._v("Bitte tragen Sie einen Namen ein")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content mt-4" }, [
          _c("div", [
            _c("span", { staticClass: "NameSpan" }, [_vm._v("Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.WLName,
                  expression: "WLName",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { type: "text", maxlength: "100", required: "" },
              domProps: { value: _vm.WLName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.WLName = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "Red", display: "none" } }, [
              _vm._v("*"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "NameSpan" }, [_vm._v("Kommentar")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.WLComment,
                  expression: "WLComment",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { type: "text", maxlength: "200" },
              domProps: { value: _vm.WLComment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.WLComment = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "Red", display: "none" } }, [
              _vm._v("*"),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wishlist-footer mt-4" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              staticClass: "second-btn",
              attrs: { type: "button", value: "Schließen" },
              on: {
                click: function ($event) {
                  return _vm.modalClose()
                },
              },
            }),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("input", {
        staticClass: "first-btn",
        attrs: { type: "submit", value: "Speichern" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }